// Column and view-preset definitions for the Orders table.

export const COLUMN_GROUPS = [
  {
    label: 'Identity',
    columns: [
      { key: 'external_order_id', label: 'Order', pinned: true },
      { key: 'date_of_order', label: 'Date' },
      { key: 'channel', label: 'Channel' },
      { key: 'order_status', label: 'Status' },
    ],
  },
  {
    label: 'Order',
    columns: [
      { key: 'items', label: 'Items' },
      { key: 'customer', label: 'Customer' },
    ],
  },
  {
    label: 'Financials',
    columns: [
      { key: 'gross_sales', label: 'Gross Sales' },
      { key: 'discounts', label: 'Discounts' },
      { key: 'taxes', label: 'Taxes' },
      { key: 'shipping_charges', label: 'Shipping' },
      { key: 'refund_total', label: 'Refunds' },
      { key: 'total_paid', label: 'Total Paid' },
      { key: 'landed_cost', label: 'Landed Cost' },
      { key: 'weighted_cost', label: 'Weighted Cost' },
      { key: 'margin', label: 'Margin %' },
    ],
  },
  {
    label: 'Fulfillment',
    columns: [
      { key: 'box_name', label: 'Box Name' },
      { key: 'earliest_ship_date', label: 'Earliest Ship' },
      { key: 'latest_ship_date', label: 'Latest Ship' },
    ],
  },
  {
    label: 'Attribution',
    columns: [
      { key: 'utm_source', label: 'UTM Source' },
      { key: 'utm_medium', label: 'UTM Medium' },
      { key: 'utm_campaign', label: 'UTM Campaign' },
      { key: 'referring_site', label: 'Referring Site' },
    ],
  },
];

export const ALL_COLUMNS = COLUMN_GROUPS.flatMap((g) => g.columns);

export const ALL_COLUMN_KEYS = ALL_COLUMNS.map((c) => c.key);

export const DEFAULT_VIEW_COLUMNS = [
  'external_order_id',
  'date_of_order',
  'channel',
  'order_status',
  'items',
  'customer',
  'gross_sales',
  'discounts',
  'refund_total',
  'total_paid',
];

export const VIEW_PRESETS = [
  { key: 'default', label: 'Default View', columns: DEFAULT_VIEW_COLUMNS },
  {
    key: 'financials',
    label: 'Financials',
    columns: [
      'external_order_id',
      'date_of_order',
      'channel',
      'order_status',
      'gross_sales',
      'discounts',
      'taxes',
      'shipping_charges',
      'refund_total',
      'total_paid',
      'landed_cost',
      'weighted_cost',
      'margin',
    ],
  },
  {
    key: 'fulfillment',
    label: 'Fulfillment',
    columns: [
      'external_order_id',
      'date_of_order',
      'channel',
      'order_status',
      'items',
      'box_name',
      'earliest_ship_date',
      'latest_ship_date',
    ],
  },
  {
    key: 'attribution',
    label: 'Attribution',
    columns: [
      'external_order_id',
      'date_of_order',
      'channel',
      'customer',
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'referring_site',
      'total_paid',
    ],
  },
];

export const RIGHT_ALIGNED_COLUMNS = [
  'gross_sales',
  'discounts',
  'taxes',
  'shipping_charges',
  'refund_total',
  'total_paid',
  'landed_cost',
  'weighted_cost',
  'margin',
];
